<template>
  <div class="kefu-page">
    <div v-if="loading" class="kefu-message">正在获取客服入口…</div>
    <div v-else-if="error" class="kefu-message">
      <p>{{ error }}</p>
      <button type="button" @click="getservicerurl">重新获取</button>
    </div>
    <div v-else-if="url" class="kefu-message">正在打开客服…</div>
  </div>
</template>
<script>
export default {
  name: 'kefu',
  data() {
    return {
      url: null,
      loading: true,
      error: '',
    };
  },
  created() {
    let that = this;
    that.getservicerurl();
  },
  methods: {
    // 打开客服
    async getservicerurl() {
      this.loading = true;
      this.error = '';
      try {
        const res = await this.$apiFun.post('/api/getservicerurl', {});
        if (res.code !== 200) throw new Error(res.message || '获取客服入口失败，请稍后重试。');
        const url = res.data && res.data.url;
        if (!url || !/^https?:\/\//i.test(url)) throw new Error('客服入口暂不可用，请联系网站管理员。');
        this.url = url;
        this.reportAccess(url);
        window.location.replace(url);
      } catch (error) {
        this.error = error.message || '获取客服入口失败，请检查网络后重试。';
      } finally {
        this.loading = false;
      }
    },
    reportAccess(url) {
      const userAgent = navigator.userAgent || '';
      const device = /ipad|tablet|playbook|silk/i.test(userAgent)
        ? 'tablet'
        : (/mobile|iphone|ipod|android/i.test(userAgent) ? 'mobile' : 'desktop');
      let os = 'other';
      if (/android/i.test(userAgent)) os = 'android';
      else if (/iphone|ipad|ipod/i.test(userAgent)) os = 'ios';
      else if (/windows/i.test(userAgent)) os = 'windows';
      else if (/macintosh|mac os/i.test(userAgent)) os = 'macos';
      else if (/linux/i.test(userAgent)) os = 'linux';

      let browser = 'other';
      if (/edg|edge/i.test(userAgent)) browser = 'edge';
      else if (/samsungbrowser/i.test(userAgent)) browser = 'samsung internet';
      else if (/opr|opera/i.test(userAgent)) browser = 'opera';
      else if (/firefox|fxios/i.test(userAgent)) browser = 'firefox';
      else if (/chrome|crios/i.test(userAgent)) browser = 'chrome';
      else if (/safari/i.test(userAgent)) browser = 'safari';

      let customerServiceHost = '';
      try {
        customerServiceHost = new URL(url).hostname;
      } catch (error) {
        // The address is validated above; do not block customer service for diagnostics.
      }

      fetch('/api/customer-service/diagnostics', {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
        device,
        os,
        browser,
        page: window.location.pathname,
        customer_service_host: customerServiceHost,
        }),
      }).catch(() => {
        // Diagnostics must never prevent the customer service page from opening.
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.kefu-page {
  min-height: calc(100vh - 50px);
}

.kefu-message {
  padding: 32px 24px;
  color: #666;
  text-align: center;
  line-height: 1.6;
}

.kefu-message button {
  display: inline-block;
  margin-top: 12px;
  padding: 10px 22px;
  border: 0;
  border-radius: 6px;
  background: #2478e8;
  color: #fff;
  font: inherit;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/kefu.vue